import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import { useSelector } from 'react-redux'
import { selectTranslations } from '../../../services/i18n/i18nSlice'
import UploadButton from '../../../components/UploadButton'
import SecureImage from '../../../components/_partials/SecuredImage'
import { API_URL } from '../../../config/constants'
import trash_img from '../../../assets/images/trash.svg'

export default function TopicModal({ show, isEditing, formData, subjects, onChange, onSubmit, onClose }) {
    const t = useSelector(selectTranslations)

    return (
        <Modal show={show} onHide={onClose} centered>
            <Modal.Body>
                <h2 className="text-center">{isEditing ? t.question_bank.edit_topic : t.question_bank.new_topic}</h2>
                <Form onSubmit={onSubmit}>
                    <Form.Group className="mb-3 mt-3" controlId="topic_subject">
                        <Form.Label>{t.question_bank.subject}</Form.Label>
                        <Form.Select value={formData.subject_id || ''} onChange={(e) => onChange('subject_id', e.target.value)} required>
                            <option value="">{t.question_bank.select_subject}</option>
                            {subjects?.map(s => (
                                <option key={s.subject_id} value={s.subject_id}>{s.subject_name}</option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="topic_name">
                        <Form.Label>{t.question_bank.topic_name}</Form.Label>
                        <Form.Control
                            type="text"
                            value={formData.topic_name || ''}
                            onChange={(e) => onChange('topic_name', e.target.value)}
                            required
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label className="d-block">{t.question_bank.icon}</Form.Label>
                        {formData.icon_url ?
                            <div className="question_bank_icon_preview">
                                <div style={{ maxWidth: '40px' }}>
                                    <SecureImage className="w-100" imageUrl={`${API_URL}${formData.icon_url}`} />
                                </div>
                                <img src={trash_img} className="pointer ms-2" onClick={() => onChange('icon_url', null)} alt="" />
                            </div>
                            :
                            <UploadButton
                                className="secondary"
                                accept="image/png, image/jpeg, image/jpg"
                                label={t.question.file}
                                type="questions"
                                onUpload={(file_url) => onChange('icon_url', `${file_url}`)}
                            />
                        }
                    </Form.Group>
                    <div className="d-flex justify-content-center mt-3">
                        <button type="submit">{isEditing ? t.buttons.edit_save : t.buttons.save_create}</button>
                        <button type="button" className="ms-2 secondary" onClick={onClose}>{t.modals.abort}</button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    )
}
